import React from 'react';
import {startCase} from 'lodash';

import type {QuestionSetModelV1} from 'resources/augmented/QuestionSet/QuestionSetModel.v1';

import './free-response-question-sub-type-badge.scss';

interface Props {
  question: QuestionSetModelV1;
}

export default function FreeResponseQuestionSubTypeBadge({question}: Props) {
  const questionSubType = question.getQuestionSubType();
  if (!questionSubType) {
    return null;
  }

  return (
    <div
      className={`free-response-question-sub-type-badge free-response-question-sub-type-badge--${questionSubType}`}
    >
      {startCase(questionSubType.replace('_question', ''))}
    </div>
  );
}
